import { FelaCSS, colors, spacing } from '@bridebook/ui';
import { ICarouselState, PREV } from './lightweight-carousel';

interface IStyles {
  imageWrap: FelaCSS;
  container: FelaCSS;
  counter: FelaCSS;
  imageStyle: FelaCSS;
  slidesWrap: ({
    sliding,
    direction,
    count,
  }: {
    sliding: ICarouselState['sliding'];
    direction: ICarouselState['direction'];
    count: number;
  }) => FelaCSS;
  loadCarouselStyle: (order: number) => FelaCSS;
  imageFilter: (currentImageLoaded: boolean) => FelaCSS;
}

const linearGradient = (currentImageLoaded: boolean, fullBleed?: boolean) => {
  if (!currentImageLoaded) return 'none';

  return fullBleed
    ? 'linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%)'
    : 'linear-gradient(to bottom,rgba(0,0,0,0.4) 0%,transparent 30%), linear-gradient(to top,rgba(0,0,0,0.3) 0%,transparent 30%)';
};

interface IProps {
  fullBleed?: boolean;
  limitImageOverflow?: boolean;
}

const styles = ({ fullBleed, limitImageOverflow }: IProps): IStyles => ({
  imageWrap: {
    display: 'block',
    position: 'relative',
    backfaceVisibility: 'hidden',
    height: '100%',
  },

  container: {
    position: 'relative',
    backgroundColor: colors.space15,
    height: '100%',
  },

  counter: {
    position: 'absolute',
    bottom: spacing[4],
    right: spacing[4],
  },

  slidesWrap: ({ sliding, direction, count }) => {
    let transform;
    if (count > 1) {
      if (!sliding) transform = 'translateX(calc(-100%))';
      else if (direction === PREV) transform = 'translateX(calc(2 * (-100%)))';
      else {
        transform = 'translateX(0%)';
      }
    }

    return {
      position: 'relative',
      flexDirection: 'row',
      width: '100%',
      maxHeight: '100%',
      height: '100%',
      '-webkit-perspective': 1000,
      '-webkit-backface-visibility': 'hidden',
      display: 'flex',
      transition: sliding ? 'none' : 'transform 0.25s ease 0ms',
      transform,
    };
  },

  loadCarouselStyle: (order: number): FelaCSS => ({
    flex: '1 0 100%',
    marginRight: '0',
    order,
    position: 'relative',
    maxHeight: '100%',
    height: '100%',
  }),

  imageStyle: {
    maxHeight: '100%',
    height: '100%',
    ...(limitImageOverflow && {
      display: 'contents',
    }),
  },

  imageFilter: (currentImageLoaded): FelaCSS => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundImage: linearGradient(currentImageLoaded, fullBleed),
  }),
});

export default styles;
